































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Lists from './Service/Lists';
import Info from './Service/DepartmentInfo';
import applyForm from './form';
import advSearch from './advSearch.vue';
import panelGroup from './components/panel-group.vue';
import $i18n from '@/modules/FPKG-20000-Util/lang'; // 取得多國文本
import Delete from './Service/Delete';

import {
  getMonthEndDate,
  getMonthStartDate,
} from '@/modules/FPKG-20000-Util/prototypes/TimeLib';

@Component({
  components: {
    advSearch,
    panelGroup,
  },
})
export default class manageLists extends Vue {
  @Prop({
    default() {
      return { width: 0, height: 0 };
    },
  })
  private contentSize!: any;

  private loading: boolean = false; // 讀取中

  private applyForm: Object = applyForm;

  private tableData: Array<Object> = [];

  private selected: Array<Object> = [];

  private dialogModify: boolean = false;

  private dialogAdvSearch: boolean = false;

  private modifydata = {};

  private subtotal: number = 0;
  private total: number = 0;
  private security_code: string = '';

  private dpeInfo: Array<object> = [];

  public checkSelectable(item: any) {
    return item.p9_ton_check_status !== null;
  }

  /** 刪除功能，可複選 */
  public async doDelete(item: any) {
    const doDelete = (await new Delete(item).delete()) as any;
    if (doDelete.data.code === 0) {
      this.selected = [];
      this.getLists({});
    }
  }

  // table選擇的項目
  private handleSelectionChange(val: Array<Object>): void {
    this.selected = val;
  }

  private sortChange(column: any) {
    this.$store.commit('sortChange', column);
  }

  /**
   * setModify 編輯功能
   */
  public setModify(item: any) {
    this.dialogModify = true;
    this.modifydata = item;
    // const guid = item.p5_role_id;
    // this.$router.push(`/transaction/apply/modify?p3_ant_id=${guid}`);
  }

  /** Info */
  private async getDepInfo() {
    const getter = (await new Info().get()) as any;
    this.dpeInfo = getter;
  }

  /** 取得列表 */
  public async getLists(params?: any) {
    /**
     * 二次密碼
     */
    this.$prompt('', `${$i18n.t('Transaction.securityCode')}`, {
      confirmButtonText: `${$i18n.t('Util.enter')}`,
      cancelButtonText: `${$i18n.t('Util.cancel')}`,
    })
      .then(async (value: any) => {
        this.security_code = value.value;
        params.p12_cig_security_code = this.security_code;
        const getter = (await new Lists(params).get()) as any;
        this.tableData = getter.list ? getter.list : [];
        this.subtotal = getter.subtotal ? getter.subtotal : 0;
        this.total = getter.stored_total
          ? Number(getter.stored_total) - Number(getter.auction_total)
          : 0;
      })
      .catch((e) => {});
  }

  private mounted() {
    /** 從bus偵測刪除行為(複選) */
    this.$bus.$on('delete', () => {
      this.doDelete(this.selected);
    });
    /** 從bus偵測新增行為 */
    this.$bus.$on('create', () => {
      this.$router.push('/transaction/apply/create');
    });

    /** 從bus偵測刪除行為(複選) */
    this.$bus.$on('advSearch', () => {
      this.dialogAdvSearch = true;
    });

    const s1 = getMonthStartDate();
    const s2 = getMonthEndDate();
    const params = {} as any;
    params.search_p9_ton_created_at_start = `${s1} 00:00:00`;
    params.search_p9_ton_created_at_end = `${s2} 23:59:59`;
    this.$router.push({ params });
    this.getLists(params);
    this.getDepInfo();
  }

  beforeRouteUpdate(to: any, from: any, next: Function) {
    next();
    this.getLists({});
  }
}
